import React, { useState, useEffect } from 'react';
import { API_URL, storedData, secret_key } from '../components/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import loading1 from '../assets/loading.gif';

function Statement() {
  const [searchTerm, setSearchTerm] = useState('');
  const [Statement, setStatement] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [originalBal, setOriginalBal] = useState(0);
  const [runningBalances, setRunningBalances] = useState({});

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

  const fetchStatement = async () => {
    try {
      const response = await axios.get(`${API_URL}/statement/${logeduserData?.company_id}?page=${page}&limit=${500000}`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.data.length === 0) {
        setHasMore(false);
      } else {
        setStatement([...Statement, ...response.data]);
        setPage(page + 1);
      }
    } catch (error) {
      console.error('Error fetching Statement:', error);
    }
  };

  const fetchOriginalBal = async () => {
    try {
      const response = await axios.get(`${API_URL}/original_bal/${logeduserData?.company_id}`, {
        headers: {
          Authorization: token,
        },
      });

      setOriginalBal(parseFloat(response.data.original_bal));
    } catch (error) {
      console.error('Error fetching Original Balance:', error);
    }
  };

  useEffect(() => {
    fetchOriginalBal();
    fetchStatement();
  }, []);

  useEffect(() => {
    const calculateRunningBalances = () => {
      const sortedStatement = [...Statement].sort((a, b) => {
        return new Date(a.formatted_date) - new Date(b.formatted_date);
      });

      let currentBalance = 0;

      const balances = {};
      sortedStatement.forEach((statement) => {
        const date = statement.formatted_date;
        const entry = parseFloat(statement.entry);
        const debit = parseFloat(statement.dr);
        const credit = parseFloat(statement.cr);

        if (!balances[date]) {
          balances[date] = currentBalance;
        }

        currentBalance = balances[date] + (debit -credit);
        balances[date] = currentBalance;
      });

      setRunningBalances(balances);
    };

    if (Statement.length > 0) {
      calculateRunningBalances();
    }
  }, [Statement, originalBal]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchStatement();
  };

  const filteredStatement = Statement.filter((Statement) => {
    const { formatted_date } = Statement;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      formatted_date.toString().toLowerCase().includes(lowerCaseSearchTerm) 
    );
  });

  const loadMoreStatement = () => {
    fetchStatement();
  };

  return (
    <div style={{ paddingLeft: '10px' }}>

        <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Statement</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Statement</li>
                  </ol>
                </div>
              </div>
            </div>
        </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

<InfiniteScroll
  dataLength={Statement.length}
  next={loadMoreStatement}
  hasMore={hasMore}
  loader={
    Statement.length > 0 ? null : (
      <div className="loadingsubcontainer">
        <img className="loadingsubimg" src={loading1} alt="Loading..." />
      </div>
    )
  }
  endMessage={<p style={{ textAlign: 'center', marginTop: '1rem' }}><b>No more statements to load.</b></p>}
>
  <div className="table-responsive">
    <table id="example" className="table table-striped table-bordered">
      <thead className="thead-dark">
        <tr>
          <th>Date</th>
          <th>Entry</th>
          <th>Dr</th>
          <th>Cr</th>
          <th>Units Bal</th>
        </tr>
      </thead>
      <tbody>
        {filteredStatement.map((statement, index) => (
          <tr key={index}>
            <td>{statement.formatted_date}</td>
            <td>{statement.entry}</td>
            <td>{parseFloat(statement.dr).toFixed(0)}</td>
            <td>{parseFloat(statement.cr).toFixed(0)}</td>
            <td>{parseFloat(runningBalances[statement.formatted_date]).toFixed(0)}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
          <td colSpan="2">TOTAL</td>
          <td>
            {filteredStatement
              .reduce((total, s) => total + parseFloat(s.dr || 0), 0)
              .toFixed(0)}
          </td>
          <td>
            {filteredStatement
              .reduce((total, s) => total + parseFloat(s.cr || 0), 0)
              .toFixed(0)}
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</InfiniteScroll>

    </div>
  );
}

export default Statement;

